import React from 'react';
import PropTypes from 'prop-types';
import AudienceCount from '../containers/AudienceCount';

const PaymentBreakdown = ({ email, push, sms, canSendSms }) => (
  <div>
    <div className="c-panel c-panel--small-radius c-panel--flat c-panel--border u-bg-white u-ph0 u-pv-">
      <div className="o-tableize">
        <div className="o-tableize__row">
          <div className="o-tableize__cell u-pv- u-pl">{email} Emails</div>
        </div>
        <div className="o-tableize__row">
          <div className="o-tableize__cell u-pv- u-pl">{push} Push Notifications</div>
        </div>
        <div className="o-tableize__row" display-if={canSendSms}>
          <div className="o-tableize__cell u-pt- u-pb u-pl">{sms} Text Messages</div>
        </div>
      </div>
    </div>
    <div className="u-mt-">
      <AudienceCount />
    </div>
  </div>
);
PaymentBreakdown.propTypes = {
  email: PropTypes.number,
  push: PropTypes.number,
  sms: PropTypes.number,
  canSendSms: PropTypes.bool,
};
PaymentBreakdown.defaultProps = {
  email: 0,
  push: 0,
  sms: 0,
  canSendSms: true,
};

export default PaymentBreakdown;
